import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';

/**
 * /game/ref/:slug landing.
 * Hits backend to record visit + award sender, stores slug + expiry in
 * localStorage, then redirects to home where the FOMO banner will appear.
 */
export default function RefLanding() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) {
      navigate('/');
      return;
    }
    axios.get(`${API}/api/referrals/${slug}/visit`)
      .then(r => {
        const data = r.data || {};
        const windowMin = data.referral_window_minutes || 10;
        try {
          localStorage.setItem('referral_slug', slug);
          localStorage.setItem('referral_inviter', data.inviter_name || 'игрок');
          localStorage.setItem('referral_welcome_points', String(data.welcome_points || 0));
          localStorage.setItem('referral_hint_cost', String(data.hint_coordinates_cost || 30));
          localStorage.setItem('referral_expires_at', String(Date.now() + windowMin * 60 * 1000));
          try { window.dispatchEvent(new Event('referral-stored')); } catch (e) { /* ignore */ }
        } catch (e) { /* localStorage may be disabled */ }
        navigate('/', { replace: true });
      })
      .catch((e) => {
        setError(e?.response?.data?.detail || 'Ссылка не найдена');
        setTimeout(() => navigate('/', { replace: true }), 2500);
      });
  }, [slug, navigate]);

  return (
    <div data-testid="ref-landing" style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0a1929', color: 'white', padding: '2rem', textAlign: 'center'
    }}>
      <div>
        {error ? (
          <div>
            <div style={{ fontSize: 18, marginBottom: 12 }}>{error}</div>
            <div style={{ opacity: 0.6, fontSize: 13 }}>Перенаправляем на главную…</div>
          </div>
        ) : (
          <div style={{ fontSize: 16, opacity: 0.85 }}>Открываем приглашение…</div>
        )}
      </div>
    </div>
  );
}
